import { mapState, mapGetters } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { nodes   } from '@/globals/nodes';
import { utils   } from '@/globals/utils';

import { evtBus  } from '@/main';
    
export const tools = {
    props: {
        tool: {
            type : Object,
            required : true
        },
        isToolFocused: {
            type : Boolean,
            default : false
        },
        isToolSelected: {
            type : Boolean,
            default : false
        },
        isToolDenteActive : {
            type : Boolean,
            default : false
        },
        isToolLocationActive : {
            type : Boolean,
            default : false
        },
        isToolLabelVisible: {
            type : Boolean,
            default : false
        },
        isToolLocationVisible: {
            type : Boolean,
            default : false
        },
        isToolActive: {
            type : Boolean,
            default : false
        },
        isToolMoving: {
            type : Boolean,
            default : false
        },
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data () {
        return {
            minDistace : 30,
            localData : {
                toolObj   : null,
                transform : 'translate(0,0)',
                toolStyle : null,
            },
            localState : {
                isToolLayerActive: false,
                isToolLabelActive: false,
                showLocationTool: false,
            }
        }
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch : {
        // GET_movToolOffset(newMovToolOffset, oldMovToolOffset) {
        //     if (newMovToolOffset === oldMovToolOffset) {
        //         console.log(`rt.mov.toolOffset watcher called with no change in value : ${newMovToolOffset?.x ?? 'null'}, ${newMovToolOffset?.y ?? 'null'}`);
        //         return;
        //     }

        //     if (this.isToolMoving) {

        //         let newTransform = `translate(${newMovToolOffset.x}, ${newMovToolOffset.y})`;
        //         if (this.localData.transform != newTransform) {
        //             this.localData.transform = newTransform;
        //         }
        //     }
        //     console.log(`New rt.mov.toolOffset : ${newMovToolOffset?.x ?? 'null'}, ${newMovToolOffset?.y ?? 'null'}`);
        // },

        
        // GET_movTool(newMovTool, oldMovTool) {
        //     if (newMovTool === oldMovTool) {
        //         console.log(`rt.mov.tool watcher called with no change in value : ${newMovTool?.label.id ?? 'null'}`);
        //         return;
        //     }
        //     let isToolHover_bkp  = this.localState.isToolHover,
        //         isToolMoving_bkp = this.localState.isToolMoving;                

        //     console.log(`New rt.mov.tool : ${newMovTool?.label.id ?? 'null'}`);
        //     if (this.tool === newMovTool) {
        //         this.localState.isToolHover = true;
        //         if (this.$store.state.runtime.mov.active) {
        //             this.localState.isToolMoving = true;
        //         }
        //     }

        //     if (isToolHover_bkp != this.localState.isToolHover) {
        //         console.log(`${this.tool.id} - localState.isToolHover changed: [${this.localState.isToolHover}]`);
        //     }
        //     if (isToolMoving_bkp != this.localState.isToolMoving) {
        //         console.log(`${this.tool.id} - localState.isToolMoving changed: [${this.localState.isToolMoving}]`);
        //     }
        // },

        // GET_activeTool(newActiveTool, oldActiveTool) {
        //     if (newActiveTool === oldActiveTool) {
        //         console.log(`rt.active.tool watcher called with no change in value : ${newActiveTool?.label.id ?? 'null'}`);
        //         return;
        //     }
        //     let isToolActive_bkp = this.localState.isToolActive;

        //     this.localState.isToolActive = (this.tool.id === newActiveTool?.label.id);

        //     if (isToolActive_bkp != this.localState.isToolActive) {
        //         console.log(`${this.tool.id} - localState.isToolActive changed: [${this.localState.isToolActive}]`);
        //     }
        // },

        // GET_activeLabel(newActiveLabel, oldActiveLabel) {  
        //     if (newActiveLabel === oldActiveLabel) {
        //         console.log(`rt.active.label watcher called with no change in value : ${newActiveLabel?.label.id ?? 'null'}`);
        //         return;
        //     }
        //     let isToolLabelActive_bkp = this.localState.isToolLabelActive,
        //         isToolActiveLabelLocation_bkp = this.localState.isToolActiveLabelLocation;

        //     this.localState.activeLabel = newActiveLabel;
        //     this.localState.isToolLabelActive = (this.tool.label.id === newActiveLabel);
        //     this.localState.isToolActiveLabelLocation = this.isLocationTool && 
        //                                                 this.GET_labelLocations.get(newActiveLabel)?.includes(this.tool.label.id);

        //     if (isToolLabelActive_bkp != this.localState.isToolLabelActive) {
        //         console.log(`${this.tool.id} - localState.isToolLabelActive changed: [${this.localState.isToolLabelActive}]`);
        //     }
        // },

        // GET_activeLayer(newActiveLayer, oldActiveLayer) {  
        //     if (newActiveLayer === oldActiveLayer) {
        //         console.log(`rt.active.layer watcher called with no change in value : ${newActiveLayer?.label.id ?? 'null'}`);
        //         return;
        //     }
        //     let isToolLayerActive_bkp = this.localState.isToolLayerActive;

        //     this.localState.isToolLayerActive = (this.tool.label.layer === newActiveLayer);

        //     if (isToolLayerActive_bkp != this.localState.isToolLayerActive) {
        //         console.log(`${this.tool.id} - localState.isToolLayerActive changed: [${this.localState.isToolLayerActive}]`);
        //     }
        // },
    
        // GET_activeDenteLabelId(newActiveDenteLabelId, oldActiveDenteLabelId) {
        //     if (newActiveDenteLabelId === oldActiveDenteLabelId) {
        //         console.log(`rt.active.dente watcher called with no change in value : ${newActiveDenteLabelId ?? 'null'}`);
        //         return;
        //     }
        //     let isToolDenteActive_bkp = this.localState.isToolDenteActive;

        //     this.localState.isToolDenteActive = (this.tool.dente === newActiveDenteLabelId);

        //     if (isToolDenteActive_bkp != this.localState.isToolDenteActive) {
        //         console.log(`${this.tool.id} - localState.isToolDenteActive changed: [${this.localState.isToolDenteActive}]`);
        //     }
        // },    

        // GET_activeLocations(newActiveLocations, oldActiveLocations) {
        //     if (newActiveLocations === oldActiveLocations) {
        //         console.log(`rt.active.locations watcher called with no change in value : ${newActiveLocations?.label.id ?? 'null'}`);
        //         return;
        //     }
        //     let isToolActiveLocation_bkp = this.localState.isToolActiveLocation;

        //     this.localState.isToolActiveLocation = (newActiveLocations?.has(this.tool.label.id) ?? false);

        //     if (isToolActiveLocation_bkp != this.localState.isToolActiveLocation) {
        //         console.log(`${this.tool.id} - localState.isToolActiveLocation changed: [${this.localState.isToolActiveLocation}]`);
        //     }
        // },
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    computed: {
        ...mapState({
        }),

        ...mapGetters([
            'GET_activeLayer',
        ]),

        id() { return this.tool.id; },

        // -----------------------------------------------------------------

//        tool() { return this.GET_job?.tools[this.toolIdx]; },
        // tool() {
        //     console.log('tool', this.id, this.GET_jobLoaded, this.localData.tool);
        //     if (this.GET_jobLoaded && (!this.localData.tool)) {
        //         this.localData.tool = utils.findTool(this.GET_jobTools, this.id);
        //     }
        //     return this.localData.tool;
        // }, 
        labelNode() { return nodes.getNode(this.tool.label.id);   }, 
        layerNode() { return nodes.getNode(this.tool.label.layer) },

        // -----------------------------------------------------------------

        dente() {
            return (this.tool.locations.external.list.length > 0) 
                ? this.tool.locations.external.list[0] 
                : '';
        },

        // -----------------------------------------------------------------

        isLocationTool() {
            return this.layerNode  
                ? (this.layerNode.layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION)
                : false            
        },
        
        isInternalLocationTool() { return this.tool.label.layer == gConsts.layer.locations.TEETH_INTERNAL },

        isProbableToothTool() { return this.tool.label.layer == gConsts.layer.locations.TEETH_PROVAVEL },

        // -----------------------------------------------------------------

        isToothSegTool() {
            return (this.tool.label.layer == gConsts.layer.locations.TEETH_SEG);
        },

        isToothLETool() {
            return (this.tool.label.layer == gConsts.layer.locations.TEETH_LE);
        },

        // -----------------------------------------------------------------

        isToolActiveLabelLocation() { 
            return this.isLocationTool && this.localState.isToolLabelActive;
        },

        isToolActiveLayerLocation()   { return this.isLocationTool && this.localState.isToolLayerActive; },
        isToolInactiveLayerLocation() { return this.isLocationTool && !this.localState.isToolLayerActive; },

        // -----------------------------------------------------------------

        isPathTool() { 
            return [gConsts.tool.attrib.types.PATH, 
                    gConsts.tool.attrib.types.CURVA].includes(this.tool.attrib.type); 
        },

        // -----------------------------------------------------------------

        closedPath() {
            var layerOverride = ('closedPaths' in this.layerNode.layerTools),
                closedPath    = false;
    
            if (layerOverride) {
                closedPath = this.layerNode.layerTools.closedPaths;
            } else {
                closedPath = this.$store.state.setup.config.closedPaths;
            }   
            
            return closedPath;
        },        
    },

    // =========================================================================================

    methods: {
        mouseDown(evt, pM, toolPt) { return false; },
        mouseMove(evt, pM)         { return false; },
        mouseUp(evt, pM)           { return false; },

        // isIn(pM, svgElem, maxDist) {
        //     return utils.isIn(pM, svgElem, maxDist);
        // }

        onActivateNode(payload) {
            this.localState.isToolLabelActive = (payload.label == this.tool.label.id);
            this.localState.isToolLayerActive = (payload.layer == this.tool.label.layer);

            // Libera mostrar o location tool se não tiver label ativo ou se o label ativo é o mesmo do location tool
            if (this.layerNode && this.layerNode.layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION && this.isLocationTool) {
                if (this.localState.isToolLayerActive) {
                    this.localState.showLocationTool = (payload.label == null) || this.localState.isToolLabelActive;
                } else {
                    // this.localState.showLocationTool = false;
                    this.localState.showLocationTool = payload.step == 'step_anatomia' && payload.layer == null && payload.label == null;
                }
            }
        },
    },

    // =========================================================================================

    created() {
//        trackComputed(this);

        evtBus.$on('evt_activateNode', this.onActivateNode);
    },

    mounted() {
        this.localState.showLocationTool = false;
        // this.localState.showLocationTool = (!!this.layerNode && this.isLocationTool && this.layerNode.layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION);
    },





}